var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderResponsiveArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3286 7.05156L1.23635 7.05156L13.3286 7.05156ZM13.3286 7.05156L9.29786 12.5645L13.3286 7.05156ZM13.3286 7.05156L9.29786 1.53866L13.3286 7.05156Z",
    fill: "#004B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3286 7.05156L1.23635 7.05156M13.3286 7.05156L9.29786 12.5645M13.3286 7.05156L9.29786 1.53866",
    stroke: "#004B6B",
    strokeWidth: 1.6123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderResponsiveArrow);
export default __webpack_public_path__ + "static/media/header-responsive-arrow.1b1986ad4d6b7c30319f86450a56808d.svg";
export { ForwardRef as ReactComponent };